/** `gradeName` values on report class rows — Kindergarten through Grade 8 */
export const K8_SCHOOL_SUMMARY_GRADES = [
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
]

/** Empty set = show all grades; checked boxes narrow the list. */
export const createDefaultGradeSelection = () => new Set()
